import { StyleSheet } from 'react-native';
import Colors from '../../../../shared/theme/colors';
import Typography from '../../../../shared/constants/Typography';

const { fontWeight } = Typography;

export const globalSyncOverlayStyles = StyleSheet.create({
  container: {
    position: Typography.position.absolute,
    bottom: Typography.gap.gap14,
    left: 0,
    right: 0,
    alignItems: Typography.textAlign.centerAlign,
    zIndex: 9999,
    elevation: 9999,
  },
  banner: {
    flexDirection: 'row',
    alignItems: Typography.textAlign.centerAlign,
    paddingHorizontal: Typography.padding.padding14,
    paddingVertical: Typography.padding.padding8,
    borderRadius: Typography.radius.radius20,
    backgroundColor: 'rgba(0,0,0,0.50)',
  },
  text: {
    color: Colors.white,
    marginLeft: Typography.margin.margin8,
    fontSize: Typography.fontSize.fontSize12,
    fontWeight: fontWeight.medium,
  },
});
